import { Inject, Options, Vue } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { InvestigationFilterRequest, InvestigationTypeView, InvestigationView } from "@/shared/modules/typescript-trustapi-client/models";
import { PracticeView } from "@/shared/modules/typescript-trustapi-client/models/practice-view";
import store from "@/trust-admin-app/store";
import { EventEmitter } from "events";
import ErrorIndicator from "@/shared/components/error-indicator/index.vue";
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import InvestigationDetailsModal from "../investigation-details-modal/index.vue";

@Options({
  components: {
    LoadingIndicator,
    ErrorIndicator,
    InvestigationDetailsModal,
  },
  mixins: [
    FormatDateTimeMixin,
  ]
})
export default class PracticeInvestigationDetails extends Vue {
  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private loadingContent = false;
  private errorLoadingContent = false;
  private loadingDataSet = false;
  private errorLoadingDataSet = false;

  private sortMethod = 'desc';
  private activeSortHeader = 2;

  private investigationTypes: InvestigationTypeView[] = [];
  private investigations: InvestigationView[] = [];
  private investigationsDisplay: any[] = [];

  private tableHeadings = [
    { text: 'Trust account INV ID', value: 'id', sortMethod: 'asc', sortable: false, activeSort: false },
    { text: 'Investigation type', value: 'investigationTypeName', sortMethod: 'asc', sortable: false, activeSort: false },
    { text: 'Date', value: 'commencementDate', sortMethod: 'desc', sortable: false, activeSort: false },
    { text: 'Status', value: 'status', sortMethod: 'asc', sortable: false, activeSort: false },
    { text: 'Reply required', value: 'replyRequired', sortMethod: 'asc', sortable: false, activeSort: false },
    { text: '', value: '', sortMethod: 'asc', sortable: false, activeSort: false },
  ];

  private addInvestigations(): void {
    const investigation: InvestigationView = {
      id: null,
      latestPracticeLogData: this.selectedPractice
    };
    investigation.latestPracticeLogData.practiceId = this.selectedPractice.id;
    this.eventCtrl.emit('showAddEditInvestigationModal', investigation);
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

  created(): void {
    this.preloadData();
  }
  
  mounted(): void {
    window.scrollTo(0, 0);
    this.eventCtrl.on('reload-investigation-data', this.loadInvestigations);
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('reload-investigation-data', this.loadInvestigations);
  }

  private async preloadData(): Promise<void> {
    try {
      this.loadingDataSet = true;
      this.errorLoadingDataSet = false;
      const resp: any[] = await Promise.all([
        this.apiService.TrustTeamMemberApi?.apiV2TrustTeamMemberGetTrustTeamMembersPost(),
        this.apiService.ConfigTrustApi?.apiV2ConfigTrustGetInvestigationTypesPost(),
        this.apiService.TrustTeamMemberApi?.apiV2TrustTeamMemberGetSupervisorsGet(),
        this.loadInvestigations()
      ]);
      this.investigationTypes = resp[1].data.data as InvestigationTypeView[];
      // this.investigators = orderBy(
      //   resp[0].data.data as TrustTeamMemberView[],
      //   [data => data.displayName.toLowerCase()],
      //   'asc'
      // );
      // this.supervisorList =
      //   orderBy(
      //     resp[2].data.data as Supervisor[],
      //     [data => data.displayName.toLowerCase()],
      //     'asc'
      //   );
    } catch (err) {
      this.errorLoadingDataSet = true;
    } finally {
      this.loadingDataSet = false;
    }
  }

  private async loadInvestigations(): Promise<boolean> {
    try {
      this.loadingContent = true;
      this.errorLoadingContent = false;
      const request: InvestigationFilterRequest = {
        "keyword": '',
        "showActiveStatus": false,
        "investigationCategoryId": null,
        "isReplyRequired": false,
        "hasTrustTeamMember": true,
        "showTrainingStatus": false,
      };

      const resp: any =
        await this.apiService.InvestigationApi?.apiV2InvestigationGetInvestigationsPost(
          request
        );

      this.investigations = resp.data.data as InvestigationView[];
      this.investigationsDisplay = this.investigations.filter(i => i.latestPracticeLogData.practiceId == this.selectedPractice.id);

      // convert to display table
      for (let i = 0; i < this.investigationsDisplay.length; i++) {
        this.investigationsDisplay[i].investigationTypeName = this.investigationsDisplay[i].investigationType.name;
        this.investigationsDisplay[i].status = this.investigationsDisplay[i].investigationStatus.name;
      }

      return Promise.resolve(false);
    } catch (err) {
      this.errorLoadingContent = true;
      console.log(err);
      return Promise.reject(true);
    } finally {
      this.loadingContent = false;
    }
  }

  private showInvestigationDetails(i: InvestigationView) {
    this.eventCtrl.emit('showInvestigationDetailsModal', i);
  }

  private sortTableColumn(): void {
    // dummy function
    }
}

